export enum ClientLevel {
  GROUP = 'group',
  BRAND = 'brand',
  SITE = 'site',
}
